import React from "react";
import CarePlan from "../../components/icon-components/CarePlan";
import Dashboard from "../../components/icon-components/Home";
import Learning from "../../components/icon-components/Learning";
import Rewards from "../../components/icon-components/Rewards";
import Ultrasound from "../../components/icon-components/Ultrasound";

const HeaderIconMap: Record<string, React.ComponentType<any>> = {
  Dashboard,
  Ultrasound,
  Rewards,
  CarePlan,
  Learning,
};

export default HeaderIconMap;

